// @flow
import styled, { keyframes } from 'styled-components';
import colors from '../../assets/css/colors';

const spin = keyframes`
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
`;

export const Spin = styled.div`
	display: block;
	position: relative;
	margin: 0 auto;
	top: 40%;
	border: 16px solid ${({ is_dark }) => is_dark ? colors.nrlDarkGreen : '#f3f3f3'};
	border-radius: 50%;
	border-top: 16px solid ${colors.nrlGreen};
	width: 120px;
	height: 120px;
	animation: ${spin} 2s linear infinite;
`;

export default Spin;


// WEBPACK FOOTER //
// ./src/components/Spin/index.js